import { i18n } from '@lingui/core';

export interface BreakingSchedulePageParams {
    entityId: string;
  }

export const ROUTE_PARAM_IDENTIFIER = ':entityId';
export const ROUTE_PATH = '/breaking-schedules';
export const DASHBOARD_ROUTE_PATH = '/qaqc/dashboard/breaking-schedules';
export const TITLE = i18n._('Breaking Schedules');
